import { ShopType, CheckoutType, MultiProviderConfig } from 'types';
import { allCallMode } from 'config';
import { DishTheme } from 'config/themes';
import { Earthlink, Windstream } from 'config/providers';

export const MyDishIFramed: MultiProviderConfig = {
  name: 'MyDishIFramed',
  micrositeCode: 'MyDishIFrame',
  shopType: ShopType.MULTI_PROVIDER,
  domain: 'updater.com',
  homepage: 'https://my.dish.com/internet',
  title: 'DISH Shop For Internet',
  fallbackPhoneNumber: '855-554-2339',
  fallbackLeadModePhoneNumber: '855-554-2339',
  defaultCheckoutType: CheckoutType.CALL_MODE,
  defaultTheme: DishTheme,
  needsDcSession: false,
  updaterCrossSellActive: false,
  source: 'MyDishIFrame',
  noOffersRetry: 2,
  getCheckoutType: allCallMode,
  //TVI-1925: Only show Earthlink and Windstream for Dish online
  providers: [Earthlink, Windstream],
  iFrameConfig: {
    hideHeaderAndFooter: true,
  },
};
